import { render, staticRenderFns } from "./Zoom.vue?vue&type=template&id=490c1c1b&"
import script from "./Zoom.vue?vue&type=script&lang=js&"
export * from "./Zoom.vue?vue&type=script&lang=js&"
import style0 from "./Zoom.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports